{
  "apiKey": "AIzaSyA2VA6AYzxWESzcIP5ApJrtVgujlxOJgFo",
  "authDomain": "broox-invoicing.firebaseapp.com",
  "projectId": "broox-invoicing",
  "storageBucket": "broox-invoicing.firebasestorage.app",
  "messagingSenderId": "61094426119",
  "appId": "1:61094426119:web:dcd65de57fe7b6baf5dca2"
}